import { httpClient } from './../httpClient';
import { apiErrorHandler } from './helpers';

export const postCreatePreAuthLink = (reservationId, payload) =>
  httpClient
    .post(`/reservation/${reservationId}/security-deposit/pre-auth`, payload)
    .then(response => response.data)
    .catch(apiErrorHandler);

export const postCaptureDeposit = (reservationId, payload) =>
  httpClient
    .post(`/reservation/${reservationId}/security-deposit/capture`, payload)
    .then(response => response.data)
    .catch(apiErrorHandler);

export const postReleaseDeposit = reservationId =>
  httpClient
    .post(`/reservation/${reservationId}/security-deposit/release`)
    .then(response => response.data)
    .catch(apiErrorHandler);

export const getDepositStatus = reservationId =>
  httpClient
    .get(`/reservation/${reservationId}/security-deposit/status`)
    .then(response => response.data)
    .catch(apiErrorHandler);

// Public (no auth) — guest deposit-confirmation page, looked up by Stripe session id.
export const getDepositConfirmationBySession = sessionId =>
  httpClient
    .get(`/reservation/security-deposit/confirmation/${sessionId}`)
    .then(response => response.data)
    .catch(apiErrorHandler);
